import script from "./trade.vue?vue&type=script&setup=true&lang=js"
export * from "./trade.vue?vue&type=script&setup=true&lang=js"

import "./trade.vue?vue&type=style&index=0&id=7c2a7a52&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2a7a52"]])

export default __exports__